import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsights = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 21.577C11.4948 21.577 11.0593 21.402 10.6933 21.052C10.3273 20.702 10.1283 20.2744 10.0963 19.7693H13.9038C13.8718 20.2744 13.6728 20.702 13.3068 21.052C12.9408 21.402 12.5052 21.577 12 21.577ZM8.25 18.3845V16.8845H15.75V18.3845H8.25ZM8.40375 15.5C7.35642 14.8487 6.52733 13.9977 5.9165 12.947C5.3055 11.8965 5 10.7475 5 9.5C5 7.55133 5.6795 5.8975 7.0385 4.5385C8.3975 3.1795 10.0513 2.5 12 2.5C13.9487 2.5 15.6025 3.1795 16.9615 4.5385C18.3205 5.8975 19 7.55133 19 9.5C19 10.7475 18.6945 11.8965 18.0835 12.947C17.4727 13.9977 16.6436 14.8487 15.5962 15.5H8.40375ZM8.85 14H15.15C15.9 13.4667 16.4792 12.8083 16.8875 12.025C17.2958 11.2417 17.5 10.4 17.5 9.5C17.5 7.96667 16.9667 6.66667 15.9 5.6C14.8333 4.53333 13.5333 4 12 4C10.4667 4 9.16667 4.53333 8.1 5.6C7.03333 6.66667 6.5 7.96667 6.5 9.5C6.5 10.4 6.70417 11.2417 7.1125 12.025C7.52083 12.8083 8.1 13.4667 8.85 14Z",
		fill: "currentColor"
	})
});
export default SvgInsights;
